import type { SelectOption } from '@/shared/ui';
import { SettlementStatisticsExpenditurePatchRequestFundingTypeValue } from '../api/generated/model';

/**
 * 単独補助区分の enum（短縮エイリアス）
 */
export const FundingTypeValue = SettlementStatisticsExpenditurePatchRequestFundingTypeValue;
export type FundingTypeValue = SettlementStatisticsExpenditurePatchRequestFundingTypeValue;

/**
 * 単独補助区分の z.enum() 用バリュー配列
 */
export const fundingTypeValues = Object.values(FundingTypeValue) as [
  FundingTypeValue,
  ...FundingTypeValue[],
];

/**
 * 単独補助区分の SelectField 用オプション
 */
export const fundingTypeSelectOptions: SelectOption[] = Object.values(FundingTypeValue).map(
  (value) => ({
    label: value,
    value,
  }),
);
